import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from '@/components/ui/sonner';
import { Toaster as ShadcnToaster } from '@/components/ui/toaster';
import { ThemeProvider } from 'next-themes';
import AppRoutes from '@/routes';
import { AuthProvider } from '@/contexts/AuthContext';
import { PermissionProvider } from '@/contexts/PermissionContext';
import { IntegrationsProvider } from '@/contexts/IntegrationsContext';
import { TimezoneProvider } from '@/contexts/TimezoneContext';
import { SidebarProvider } from '@/contexts/SidebarContext';
import { TooltipProvider } from '@/components/ui/tooltip';

const queryClient = new QueryClient();

export default function App() {
  return (
    <>
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
            <Router>
              <AuthProvider>
                <PermissionProvider>
                  <TooltipProvider>
                    <IntegrationsProvider>
                      <TimezoneProvider>
                        <SidebarProvider>
                          <AppRoutes />
                          <Toaster position="top-right" offset={80} />
                          <ShadcnToaster />
                        </SidebarProvider>
                      </TimezoneProvider>
                    </IntegrationsProvider>
                  </TooltipProvider>
                </PermissionProvider>
              </AuthProvider>
            </Router>
          </ThemeProvider>
        </QueryClientProvider>
      </HelmetProvider>
    </>
  );
}
